// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"610":"5a70d6e5","687":"6524eb41"}[chunkId] + ".chunk.js";
};